import { render, staticRenderFns } from "./PerformanceMetric.vue?vue&type=template&id=2ac34206&scoped=true&"
import script from "./PerformanceMetric.vue?vue&type=script&lang=js&"
export * from "./PerformanceMetric.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceMetric.vue?vue&type=style&index=0&id=2ac34206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac34206",
  null
  
)

export default component.exports